import { render, staticRenderFns } from "./EmployeeTable.vue?vue&type=template&id=79132142&scoped=true"
import script from "./EmployeeTable.vue?vue&type=script&lang=js"
export * from "./EmployeeTable.vue?vue&type=script&lang=js"
import style0 from "./EmployeeTable.vue?vue&type=style&index=0&id=79132142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79132142",
  null
  
)

export default component.exports